import { useLang } from "@/context/LanguageContext";
import { serviceIcons } from "@/data/content";
import { Reveal, Overline } from "@/components/shared";

export const Services = () => {
  const { t } = useLang();
  const s = t.services;

  return (
    <section id="services" data-testid="services" className="border-t border-zinc-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-12 md:py-32">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <Reveal>
              <Overline>{s.overline}</Overline>
              <h2 className="mt-6 font-heading text-3xl font-light tracking-tight text-zinc-900 sm:text-5xl">
                {s.title}
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Reveal i={1}>
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">
                {String(s.items.length).padStart(2, "0")} — Capabilities
              </span>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-zinc-200 bg-zinc-200 sm:grid-cols-2 lg:grid-cols-3">
          {s.items.map((item, i) => {
            const Icon = serviceIcons[i];
            return (
              <Reveal key={item.name} i={i % 3}>
                <div
                  data-testid="service-card"
                  className="group h-full bg-white p-8 transition-colors hover:bg-zinc-50"
                >
                  <div className="flex items-start justify-between">
                    <Icon size={26} strokeWidth={1.25} className="text-zinc-900" />
                    <span className="font-mono text-xs text-zinc-300">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h3 className="mt-8 font-heading text-lg font-medium leading-snug text-zinc-900">{item.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-zinc-500">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
